import React, { useState, useEffect } from 'react';
import { Hidden, makeStyles, useTheme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { changeStatusFlagMigrationBeneficiaries } from "../../actions/loginUser";
import moment from 'moment';
import DialogConfirm from '../Complements/DialogConfirm'
import LoadingScreen from '../Complements/LoadingScreen';
import { connect, useSelector } from 'react-redux';
import { feathersCreateData, feathersFindDataAll } from '../../services';
import { history } from '../../helpers/history';
// import { isMobile } from 'react-device-detect';
import { Paper } from '@mui/material';


const useStyles = makeStyles((theme) => ({
    textcustomertitle: {
        [theme.breakpoints.up('xs')]: {
            color: '#2E2757',
            fontSize: '80%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('sm')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('md')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('lg')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('xl')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        }
    },
    textcustomerheader: {
        [theme.breakpoints.up('xs')]: {
            color: '#2E2757',
            fontSize: '80%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('sm')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('md')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('lg')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        },
        [theme.breakpoints.up('xl')]: {
            color: '#2E2757',
            fontSize: '100%',
            fontWeight: 'bold',
            //fontFamily: 'Roboto-Medium',
        }
    },
    textlastaccessheader: {
        paddingRight: '16px',
        [theme.breakpoints.up('xs')]: {
            color: '#1a1919',
            fontSize: '80%',
            //fontFamily: 'Roboto-Light',
        },
        [theme.breakpoints.up('sm')]: {
            color: '#1a1919',
            fontSize: '100%',
            //fontFamily: 'Roboto-Light',
        },
        [theme.breakpoints.up('md')]: {
            color: '#1a1919',
            fontSize: '100%',
            //fontFamily: 'Roboto-Light',
        },
        [theme.breakpoints.up('lg')]: {
            color: '#1a1919',
            fontSize: '100%',
            //fontFamily: 'Roboto-Light',
        },
        [theme.breakpoints.up('xl')]: {
            color: '#1a1919',
            fontSize: '100%',
            //fontFamily: 'Roboto-Light',
        }
    },
    textCenterHeader: {
        //fontFamily: 'Arial-Bold',
        [theme.breakpoints.up('xs')]: {
            color: '#1a1919',
            fontSize: '0.8rem'
        },
        [theme.breakpoints.up('sm')]: {
            color: '#1a1919',
            fontSize: '1.5rem'
        },
        [theme.breakpoints.up('md')]: {
            color: '#1a1919',
            fontSize: '2rem'
        },
        [theme.breakpoints.up('lg')]: {
            color: '#1a1919',
            fontSize: '2.2rem'
        },
        [theme.breakpoints.up('xl')]: {
            color: '#1a1919',
            fontSize: '2.2rem'
        }
    },
    textCenterHeaderMobile: {
        marginTop: '15px',
        color: '#2E2757',
        //fontFamily: 'MyriadPro-BoldItalic',
        [theme.breakpoints.up('xs')]: {
            fontSize: '1.25rem'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.5rem'
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '2rem'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '2.2rem'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '2.2rem'
        }
    },
    text: {
        color: theme.palette.type === 'dark' ? '#b98919' : '#312a5c'
    },
    dataTexto: {
        paddingBottom: '15px'
    }
}));


const InfoDeviceUser = props => {

    const { customer, auth, devices } = props;
    const user = useSelector(state => state.authentication?.user)
    const classes2 = useStyles()

    const [flagShowDialogMigrationBeneficiaries, setFlagShowDialogMigrationBeneficiaries] = useState(false)
    const [loading, setLoading] = useState(false)
    const [verificates, setVerificates] = useState({})
    //console.log(verificates, "verificates")

    const themePrimary = useTheme()

    const getLastSession = async () => {
        try {
            const sendData = {
                user: user.id,
                $limit: 2,
                $sort: {
                    createdAt: -1
                }
            }
            //console.log(sendData, "sendData");
            const respVarificates = await feathersFindDataAll("verificates", sendData)()
            //console.log(respVarificates, "respVarificates");
            setVerificates(respVarificates.lenth > 1 ? respVarificates[1] : respVarificates[0])
            // console.log(respVarificates[1]?.createdAt, "Última sesión");
        } catch (error) {
            console.log(error);
        }
    }

    const mount = () => {
        const unmount = () => {

            if (auth) {
                if (auth.flagResetSecurityQuestions === 1) {
                    history.push('/questions')
                } else {
                    if (auth.flagResetPassword === 1) {
                        history.push('/password-change')
                    } else {

                        if (auth.flagUsernameChange === 1) {
                            history.push('/username-change')
                        } else {
                            history.push('/')
                        }

                    }
                }
            }
        }
        return unmount()
    }

    useEffect(mount, [])

    const handleNoMigrateBenefiaries = () => {
        handleChangeStatusMigrationBeneficiaries(false)
    }

    const handleMigrateBenefiaries = () => {

        handleChangeStatusMigrationBeneficiaries(true)
    }

    const handleChangeStatusMigrationBeneficiaries = async (status) => {

        setLoading(true)

        try {

            const responseMigrationBenefiaries = await feathersCreateData("procces-migration-beneficiaries", { status })()

            //console.log(responseMigrationBenefiaries)

            if (responseMigrationBenefiaries.error === false) {

                props.changeStatusFlagMigrationBeneficiaries(0)
            }

            setFlagShowDialogMigrationBeneficiaries(false)

            setLoading(false)

        } catch (error) {
            //console.log(error)
            setLoading(false)
        }
    }
    //console.log('CUSTOMER: ', customer)

    useEffect(() => {
        getLastSession()
        // eslint-disable-next-line
    }, [])

    return (

        <div>
            <Paper elevation={0} sx={{ borderRadius: '16px !important' }}>

                <Grid container alignItems='center' style={{ padding: "8px 32px" }}>
                    <Grid sm={12} lg={8} >
                        <Typography className={classes2.text} style={{ fontSize: 28, fontWeight: 600 }}>
                            {user?.companies?.name}
                        </Typography>
                        <p style={{ color: themePrimary.palette.primary.main, }} >
                            <span style={{ textTransform: "capitalize" }}>{user?.username}</span> <br />
                            <span style={{ color: "#abacb7" }} >{customer.DocumentId}</span> <br />
                            <span style={{ color: "#abacb7" }} >Último acceso {`${moment(verificates.createdAt).format('DD/MM/YYYY')} ${moment(verificates.createdAt).format('HH:mm:ss')} ${devices.device}`} </span>
                        </p>
                    </Grid>
                    <Hidden mdDown>
                        <Grid xs={12} lg={4} style={{ textAlign: "end" }}>
                        <img src={process.env.PUBLIC_URL + '/images/banner.svg'} alt="family" style={{ width: 240 }} />
                    </Grid>
                    </Hidden>
                </Grid>

            </Paper>
            <DialogConfirm
                open={flagShowDialogMigrationBeneficiaries}
                title="Confirmación"
                description="Esta seguro que desea conservar sus beneficiarios registrados ?"
                onCloseDialog={handleNoMigrateBenefiaries}
                onAceptDialog={handleMigrateBenefiaries}
                titleButtonAccept={"Si"}
                titleButtonCancel={"No"}
            />
            <LoadingScreen open={loading} />
        </div>

    )
}

export default connect(null, { changeStatusFlagMigrationBeneficiaries })(InfoDeviceUser);

